import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=b8320b1e&scoped=true"
import script from "./banners.vue?vue&type=script&lang=js"
export * from "./banners.vue?vue&type=script&lang=js"
import style0 from "./banners.vue?vue&type=style&index=0&id=b8320b1e&prod&lang=css"
import style1 from "./banners.vue?vue&type=style&index=1&id=b8320b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8320b1e",
  null
  
)

export default component.exports